import {AlertMetadataDTO, Completable, pending} from 'kashable-mobile-common';

import {getNotificationsMetadata} from '../apis/monitoring';
import {RootState} from '../store';

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<AlertMetadataDTO> = pending();

export const fetchAlertsMetadata = createAsyncThunk(
    'alertsMetadata/fetch',
    async (alerts, {rejectWithValue}) => {
        const response = await getNotificationsMetadata();

        if (response.error) {
            rejectWithValue(response);
        }

        return response;
    },
);

export const alertsMetadataSlice = createSlice({
    name: 'alertsMetadata',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearAlertsMetadata: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAlertsMetadata.pending, () => {
                return pending();
            })
            .addCase(fetchAlertsMetadata.fulfilled, (_, action) => {
                return action.payload;
            });
    },
});


export const {
    clearAlertsMetadata,
} = alertsMetadataSlice.actions;
export const selectAlertsMetadata = (state: RootState) => state.alertsMetadata;
export default alertsMetadataSlice.reducer;
